// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__j_A_i","skeleton-animation":"styles_skeleton-animation__a0YlF"};